import { Box, Button, Stack, Typography } from "@mui/material"
import type { TelegramPreviewMedia } from "@core/components/telegram/preview/telegramMessagePreview"
import type { Media } from "../../interface/media"
import { mediaDescriptor, useMediaPreview } from "../../hooks/useMediaPreview"
import { useMediaVisibility } from "../../hooks/useMediaVisibility"

export function SavedMediaThumbnail({ media }: { media: Media }) {
  const { ref, visible } = useMediaVisibility()
  const [descriptor] = useMediaPreview(
    [media.id],
    [mediaDescriptor(media)],
    visible,
  )
  return (
    <Box ref={ref} sx={{ width: "100%" }}>
      <MediaThumbnail media={descriptor} />
    </Box>
  )
}

export function MediaThumbnail({ media }: { media: TelegramPreviewMedia }) {
  return media.previewUrl ? (
    media.kind === "video" ? (
      <Box
        component="video"
        src={media.previewUrl}
        aria-label={media.name}
        controls
        playsInline
        preload="metadata"
        onError={media.onPreviewError}
        sx={{ width: "100%", maxHeight: 160 }}
      />
    ) : (
      <Box
        component="img"
        src={media.previewUrl}
        alt={media.name}
        loading="lazy"
        onError={media.onPreviewError}
        sx={{ width: "100%", maxHeight: 160, objectFit: "contain" }}
      />
    )
  ) : (
    <Stack spacing={0.5}>
      <Typography variant="caption">
        {media.previewError ??
          (media.previewLoading
            ? "Загрузка предпросмотра…"
            : "Предпросмотр недоступен")}
      </Typography>
      {media.previewError && media.onPreviewRetry && (
        <Button size="small" onClick={media.onPreviewRetry}>
          Повторить
        </Button>
      )}
    </Stack>
  )
}
